import { t as e } from "../../chunks/index.es.wVhS2yfK.js";
import { r as t, t as n } from "../../chunks/fields.B8wePlrI.js";
// lib/TVListing/lib/actionHandler.ts
var r = ({ editor: r }) => {
	let i = e.getSelectedText(r), a = e.position(r) + +!i, o = {
		id: crypto.randomUUID(),
		class: "block",
		type: "tt/tv-listing",
		properties: { uninitialized: !0 },
		children: t(n)
	};
	e.insertAt(r, a, [o]);
};
export { r as actionHandler };
